module.exports = __webpack_public_path__ + "img/FPT00.66aaf3bc.svg";